module.exports = __webpack_public_path__ + "img/ico_2via-carteira.961a2868.svg";